export default "__VITE_ASSET__4a73eec8__"